import { makeStyles } from "@material-ui/core"

export const loadsListStyle = makeStyles((theme) => ({
    listWrapper: {
        background: 'white',
        display: 'flex',
        flexDirection: 'column',
        height: '61vh',
        //marginTop: '1em',
        "& ul": {
            flex: '1',
        height: '61vh',

        },
         minWidth: '1200px',
    },
    listItem: {
        borderBottom: '1px solid lightgrey',
    },
    flaggedLoad: {
        backgroundColor: '#ffff0029'
    }
}));